import React from "react";
import styled from "styled-components";

import { BLOCK_HEIGHT, HOURS_LIST } from "src/views/schedule/constants";

import { TMentorShiftScheduleEvent } from "../constants";

import { MentorShift } from "./MentorShift";
import { Shift } from "./Shift";

interface ShiftColumnProps {
  shifts: TMentorShiftScheduleEvent[];
  isAdmin?: boolean;
  handleRegister?: (shiftId: number, index: number, spotsLeft: number) => void;
  handleUnregister?: (
    shiftId: number,
    index: number,
    spotsLeft: number
  ) => void;
  setSelectedShift: (shiftId: number) => void;
  columnWidth: number;
}

const CalendarColumn = styled.div<{ width: number }>`
  position: relative;
  width: ${({ width }) => width}px;
  min-width: 100%;
  border-left: 1px solid #c3ccd7;
  border-bottom: 1px solid #c3ccd7;
  border-top: 1px solid #c3ccd7;
`;

const TimeBlock = styled.div`
  height: ${BLOCK_HEIGHT}px;
  width: 100%;
  :not(:first-child) {
    border-top: 1px solid #c3ccd7;
  }
`;

export const ShiftsColumn: React.FC<ShiftColumnProps> = ({
  shifts,
  isAdmin = true,
  handleRegister,
  handleUnregister,
  setSelectedShift,
  columnWidth,
}) => {
  const validateRegister = (
    shiftId: number,
    index: number,
    spotsLeft: number
  ) => {
    if (isAdmin || !handleRegister) {
      return;
    } else {
      handleRegister(shiftId, index, spotsLeft);
    }
  };

  const validateUnregister = (
    shiftId: number,
    index: number,
    spotsLeft: number
  ) => {
    if (isAdmin || !handleUnregister) {
      return;
    } else {
      handleUnregister(shiftId, index, spotsLeft);
    }
  };

  return (
    <CalendarColumn width={columnWidth}>
      {HOURS_LIST.map((hour) => (
        <TimeBlock key={hour} />
      ))}
      {shifts.map((shift, index) =>
        isAdmin ? (
          <Shift
            key={shift.id}
            shift={shift}
            setSelectedShift={setSelectedShift}
          />
        ) : (
          <MentorShift
            key={shift.id}
            shift={shift}
            isRegistered={shift.isRegistered ?? undefined}
            isDisableRegistered={shift.isDisableRegistered ?? undefined}
            handleRegister={(shiftId, spotsLeft) =>
              validateRegister(shiftId, index, spotsLeft)
            }
            handleUnregister={(shiftId, spotsLeft) =>
              validateUnregister(shiftId, index, spotsLeft)
            }
            setSelectedShift={setSelectedShift}
          />
        )
      )}
    </CalendarColumn>
  );
};
